/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import '../original/jquery.accordion';
import '../original/jquery.cookie';
import '../components/tabs.js';
import '../components/sliders.js';
import '../components/quickquote.js';
import '../components/systemSpec.js';
import '../components/emailResults.js';
import '@fancyapps/fancybox';
import 'jquery-inview';
import 'jquery-parallax.js';

const $window = $(window);
let scrolled_amount = $window.scrollTop();
let prev = 0;

export default {
	init() {

		$('[data-inview]').one('inview', function () {
			$(this).addClass('inview');
		});
		$('[data-inview-custom]').one('inview', function () {
			$(this).addClass('inview');
		});

		if ($(window).width() > 991) {
			$('.parallax-window').parallax({
				speed: 0.7,
				bleed: 50,
				iosFix: false,
				androidFix: true,
			});
		}

		//  New Menu Functionality
		/*todo: remove any old menu functionality when all new menus are integrated */

		// Check if new menu exists before running scripts.
		if ($('.top-navigation').length) {

			$('.top-navigation ul.top-navigation__links > li.has-children').mouseenter(function () {
				$('.top-navigation').addClass('dropdown-active');
				var itemCenter = $(this).offset().left + ($(this).width() / 2);
				$('.marker__left').css({
					'width': itemCenter,
				});
				$('.marker__right').css({
					'left': itemCenter,
				});
			}).mouseleave(function () {
				$('.top-navigation').removeClass('dropdown-active');
			});

			$(window).on('scroll', function () {
				scrolled_amount = $window.scrollTop();
				stickyNav();
				mobQQ();
			});

			var smLinks = $('.sub-menu__links');
			var smSide = $('.sub-menu__content');

			$('.top-navigation__links > li.has-children').on('mouseover', function () {
				var smSideH = $(this).find(smSide).height();
				var smLinksH = $(this).find('li.has-children.active').find(smLinks).height();
				if (smLinksH > smSideH) {
					$(this).find('.sub-menu').height(smLinksH);
				}
			});

			$('.sub-menu__content__side-menu li.has-children').on('mouseover', function () {
				$(this).siblings('li').removeClass('active');
				$(this).addClass('active');
				let smSideH = $(this).closest('.sub-menu__content').outerHeight();
				let smLinksH = $(this).find(smLinks).height();
				if (smLinksH > smSideH) {
					$(this).closest('.sub-menu').height(smLinksH);
				} else {
					$(this).closest('.sub-menu').height(smSideH);
				}
			});

			/* $('.sub-menu__content__side-menu li.has-children').on('mouseover', function(e) {
			  e.stopPropagation();
			  let smLinksH = $(this).find('.sub-menu__links').height();
			  let smSideH = $(this).closest('.sub-menu__content').height();
			  if (smLinksH > smSideH) {
				$(this).closest('.sub-menu').height(smLinksH);
			  }
			}); */

			// Menu Search
			if ($('.top-navigation__actions__search').length > 0) {
				$('.top-navigation__actions__search, .search-toggle').click(function () {
					$('body').toggleClass('search-active');
					$('.top-navigation__actions__search').find('i').toggleClass('fa-times fa-search');
					setTimeout(function () {
						$('#search-input').focus();
					}, 100);
				});
			}
		}

		$('[data-fancybox]').fancybox();

		// FAQ Accordion
		if ($('.faqAccordion').length > 0) {
			$('.faqAccordion').accordion({
				'transitionSpeed': 400,
			});
		}
		// FAQ Accordion v2
		if ($('.faqs__group').length > 0) {
			$('.faqs__group').accordion({
				'transitionSpeed': 400,
			});
			$('.question').accordion({
				'transitionSpeed': 400,
			});
		}

		// Home Story Accordion
		if ($('.home-story__accordion').length > 0) {
			$('.home-story__accordion').accordion({
				'transitionSpeed': 400,
				singleOpen: true,
				activate: function () {
					if ($(window).width() > 991) {
						$('.parallax-window').parallax({
							speed: 0.7,
							bleed: 50,
							iosFix: false,
							androidFix: true,
						});
					}
				},
			});
		}

		//  Home CS Section Height Fix
		if ($('.home-cs').length) {
			var csHeight = $('.home-cs .slider-outer').outerHeight();
			$('.home-cs').css({
				'min-height': csHeight,
			});
		}


	},
	finalize() {
	},
};

function mobQQ() {

	function qqOffset() {
		if ($('.quick-quote').length > 0) {
			return $('.quick-quote').offset().top;
		} else if ($window.width() < 991 && $('.quick-quote__side').length) {
			return 0;
		} else {
			return $('.quick-quote__side').offset().top + $('.quick-quote__side').outerHeight();
		}
	}

	if (scrolled_amount > qqOffset() + 100) {
		$('.quick-quote__tab').addClass('visible');
	} else {
		$('.quick-quote__tab').removeClass('visible');
	}
}

function stickyNav() {
	var docHeight = $(document).outerHeight();
	var windowHeight = $(window).outerHeight();
	var endCap = docHeight - windowHeight - 300;
	if (scrolled_amount > 200) {
		$('body').addClass('sticky-nav nav-show');
		if (scrolled_amount > 500 && scrolled_amount < endCap) {
			$('body').toggleClass('nav-up', scrolled_amount > prev);
			prev = scrolled_amount;
		}
		if (scrolled_amount > endCap) {
			$('body').removeClass('nav-up');
		}
	} else {
		$('body').removeClass('sticky-nav nav-show');
	}
}


// WEBPACK FOOTER //
// ./scripts/routes/common.js